import { render, staticRenderFns } from "./LookFeel.vue?vue&type=template&id=3b967010"
import script from "./LookFeel.vue?vue&type=script&lang=js"
export * from "./LookFeel.vue?vue&type=script&lang=js"
import style0 from "./LookFeel.vue?vue&type=style&index=0&id=3b967010&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports